<app-admin-nav></app-admin-nav>
<div *ngIf="isLoading" class="outer-spinner">
  <div class="loading-spinner"></div>
</div>
<div class="outside">
  <div class="head">
    <h1>Support Agents</h1>
    <button class="btn btn-primary" (click)="handleClick()">Add</button>
  </div>
  <div class="table-responsive table-container table-sm mt-4">
    <table class="table">
      <thead>
        <tr>
          <th class="col-1">No.</th>
          <th class="col-3">Name</th>
          <th class="col-6">Email</th>
          <th class="col-2" style="text-align: center">Action</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let agent of agents; let i = index">
          <td>{{ i }}</td>
          <td>{{ agent.name }}</td>
          <td>{{ agent.email }}</td>

          <td>
            <div class="d-none d-md-block">
              <div
                style="
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  gap: 20px;
                "
              >
                <a (click)="editAgent(agent)">
                  <button class="btn btn-sm btn-primary">Edit</button>
                </a>
                <button
                  class="btn btn-sm btn-danger"
                  (click)="deleteAgent(agent.id)"
                >
                  Delete
                </button>
              </div>
            </div>

            <div class="d-block d-md-none">
              <div
                style="
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  gap: 20px;
                "
              >
                <a (click)="editAgent(agent)">
                  <i class="fas fa-edit text-primary mr-2"></i>
                </a>
                <i
                  class="fas fa-trash text-danger"
                  (click)="deleteAgent(agent.id)"
                ></i>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
